import React from 'react';
import {
  ChoiceButton,
  ChoiceButtonGroup,
  FormGroup,
  Input,
  Label,
} from '../../../../styles/lesson/lesson.style';
import {
  useLessonCreationState,
  useLessonCreationDispatch,
  Frequency,
} from '../lessonCreation.state';

export const Step4_Frequency: React.FC = () => {
  // Get state and dispatch from the context
  const { frequency, occurrenceCount } = useLessonCreationState();
  const dispatch = useLessonCreationDispatch();

  // --- Handlers ---
  const handleFrequencyChange = (freq: Frequency) => {
    dispatch({ type: 'SET_FREQUENCY', payload: freq });
  };

  const handleCountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Ensure count is between 1 and 52
    const count = Math.max(
      1,
      Math.min(52, Number(e.target.value) || 1),
    );
    dispatch({ type: 'SET_OCCURRENCE_COUNT', payload: count });
  };

  // --- Render ---
  return (
    <>
      <ChoiceButtonGroup>
        <ChoiceButton
          isSelected={frequency === 'daily'}
          onClick={() => handleFrequencyChange('daily')}
        >
          Daily
        </ChoiceButton>
        <ChoiceButton
          isSelected={frequency === 'weekly'}
          onClick={() => handleFrequencyChange('weekly')}
        >
          Weekly
        </ChoiceButton>
        <ChoiceButton
          isSelected={frequency === 'biweekly'}
          onClick={() => handleFrequencyChange('biweekly')}
        >
          Every two weeks
        </ChoiceButton>
        <ChoiceButton
          isSelected={frequency === 'monthly'}
          onClick={() => handleFrequencyChange('monthly')}
        >
          Monthly
        </ChoiceButton>
      </ChoiceButtonGroup>

      <FormGroup>
        <Label htmlFor="occurrences" css={{ marginBottom: '1rem' }}>
          How many lessons should we create?
        </Label>
        <Input
          type="number"
          id="occurrences"
          min={1}
          max={52}
          value={occurrenceCount}
          onChange={handleCountChange}
        />
      </FormGroup>
    </>
  );
};